import { render, staticRenderFns } from "./ContactForms.vue?vue&type=template&id=23614439&scoped=true"
import script from "./ContactForms.vue?vue&type=script&lang=js"
export * from "./ContactForms.vue?vue&type=script&lang=js"
import style0 from "./ContactForms.vue?vue&type=style&index=0&id=23614439&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23614439",
  null
  
)

export default component.exports